import store from '@/store'

function parseJWT(token) {
  if (!token) {
    return
  }

  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join(''),
  )
  return JSON.parse(jsonPayload)
}

export default {
  namespaced: true,
  state: {
    jwt: null,
  },

  mutations: {
    setPermissionData(_, jwt) {
      localStorage.setItem('permissions', jwt)
    },

    setPermissionDataToState(state, jwt) {
      state.jwt = jwt
    },
  },

  actions: {
    getPermissionData({ commit }) {
      const jwt = parseJWT(localStorage.getItem('permissions'))
      commit('setPermissionDataToState', jwt)
    },
  },

  getters: {
    check: (state) => (unique_name) => {
      if (!state.jwt) {
        store.dispatch('permission/getPermissionData')
      }

      return unique_name
        ? state.jwt?.data?.some((item) => item.module === unique_name)
        : false
    },
  },
}
